import databaseContent from "../databaseContent";

/**
 * Серверный доступ к контенту nestFarkopDatabase (только из pages/api/*).
 */
export default (axios: any, config: any) => {
  const api = databaseContent(axios, config);

  return {
    getDomains(Redis: any, reset = false) {
      return api.getDomains(Redis, reset);
    },
  };
};
